import * as footerStyles from "../../../styles/layout/footer.module.scss";
import IconContainer from "../../shared/IconContainer";
import {toExternalUrl} from "../../../utils/utils"
import AppButton from "../../shared/AppButton";
import Image from "../../shared/Image";

import React, {Fragment} from "react";
import {useTranslation, getI18n} from "react-i18next";
import {Link} from "gatsby";


const Footer = React.memo(function Footer({footer, locale}) {
    const {t} = useTranslation();
    let footerLogo = footer?.logo;
    const copyRightDate = (new Date()).getFullYear()

    if (locale !== null && getI18n().language !== locale) {
        getI18n().changeLanguage(locale);
    }

    return (<>
        <div className={footerStyles.footerContainer}>
            <div className={footerStyles.mainContainer}>
                <div className={footerStyles.contactContainer}>
                    <div className={footerStyles.logoContainer}>
                        {footerLogo && (<Link to={footerLogo.navigationPath} aria-label={t("footer.logos.main.arialabel", {website: 'Sciences Po'})}>
                            <Image className={footerStyles.logoImg} image={footerLogo}
                                   aria-label={t("header.logo")}/>
                        </Link>)}
                    </div>

                    <div className={footerStyles.addressContainer}>
                        <p className={footerStyles.contactTitle}>
                            {t("footer.address.and.phone")}
                        </p>

                        <p className={footerStyles.address}>
                            {footer?.address || "27, rue Saint Guillaume - 75007 Paris Cedex 07"}
                        </p>

                        <p className={footerStyles.phone}>
                            {t("footer.phone.abbreviation")} {footer?.phone} | {footer?.fax}
                        </p>
                    </div>
                </div>

                <div className={footerStyles.mediaContainer}>
                    {footer?.SocialNetworks?.length > 0 && (<div className={footerStyles.socialMediaContainer}>
                        <p className={footerStyles.socialMediaTitle}>
                            {t("footer.follow.us")}
                        </p>

                        <div className={footerStyles.socialMediaIconContainer}>
                            <ul className={footerStyles.socialMediaList}>
                                {footer?.SocialNetworks?.map((network, index) => (
                                    <li className={footerStyles.socialMediaItem} key={index}>
                                        <a className={footerStyles.socialMediaAnchor} href={network.link}
                                           target="_blank" rel="noreferrer"
                                           title={network.type + t("footer.social.networks")}
                                           aria-label={network.type + t("footer.social.networks")}>
                                            <IconContainer icon={network.type} color="WHITE" size={25}/>
                                        </a>
                                    </li>))
                                }
                            </ul>
                        </div>
                    </div>)}

                    <div className={footerStyles.newsletterContainer}>
                        <p className={footerStyles.newsletterTitle}>
                            {t("footer.newsletters.subscription")}
                        </p>

                        <div className={footerStyles.newsletterButtonContainer}>
                            <AppButton
                                color="secondary"
                                variant="contained"
                                label={footer?.NewsletterSubscription?.label}
                                tabIndex="0"
                                padding={10}
                                noBorder
                                width="80%"
                                onClick={() =>
                                    typeof window !== `undefined` &&
                                    window.open(toExternalUrl(footer?.NewsletterSubscription?.link), "_blank")
                                }
                                onKeyDown={(e) => {
                                        if (e.key !== "Tab") {
                                            typeof window !== `undefined` &&
                                            window.open(toExternalUrl(footer?.NewsletterSubscription?.link), "_blank")
                                        }
                                    }
                                }
                            >
                                <p className={footerStyles.smartNewsletterButtonTitle}>
                                    {footer?.NewsletterSubscription?.label}
                                </p>
                            </AppButton>
                        </div>
                    </div>
                </div>

                <div className={footerStyles.miscellaneousContainer}>
                    {footer?.group_of_additional_links?.map((group, index) => (
                        <div className={footerStyles.linkBlocContainer} key={index}>
                            <div className={footerStyles.linkBlocContent}>
                                <p className={footerStyles.linkBlocTitle}>
                                    {group.title}
                                </p>

                                <ul>
                                    {group?.links?.map((link, subindex) => {
                                        if (link.label && link.URI) {
                                            return (
                                                <li className={footerStyles.linkItem} key={`${index}-${subindex}`}>
                                                    <div className={footerStyles.linkContainer}>
                                                        <a className={footerStyles.link} aria-label={link.label}
                                                           href={toExternalUrl(link.URI)}
                                                           title={link.alternativeTest}>
                                                            {link.label}
                                                        </a>
                                                    </div>
                                                </li>)
                                        }
                                        return <Fragment key={`${index}-${subindex}`}/>;
                                    })}
                                </ul>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>

        <div className={footerStyles.copyrightContainer}>
            <p className={footerStyles.copyright}>
                ©{t("footer.author", {date: copyRightDate})}
            </p>
        </div>
    </>)
});

export default Footer;
